export const env = {
  apiBase: import.meta.env.VITE_API_BASE ?? '/api/v1',
  appTitle: import.meta.env.VITE_APP_TITLE ?? '商户管理后台',
};
